<template>
  <!-- 雇佣服务 -->
  <div class="employmentPlan">
    <div class="banner_video" :id="'elm' + elmentList[0].id">
      <img :src="elmentList[0].pcImg" v-if="$store.state.pageset.pcshow" />
      <img :src="elmentList[0].phoneImg" v-else />
      <div class="img-con">
        <div class="title">
          <p class="p2">
            {{ elmentList[0].descList[0].descName }}&nbsp;&nbsp;{{
              elmentList[0].descList[1].descName
            }}
          </p>
          <p class="p2">
            {{ elmentList[0].descList[2].descName }}&nbsp;&nbsp;{{
              elmentList[0].descList[3].descName
            }}
          </p>
        </div>
      </div>
    </div>

    <div class="banner-two" :id="'elm' + elmentList[1].id">
      <div class="img-con">
        <img :src="elmentList[1].pcImg" v-if="$store.state.pageset.pcshow" />
        <img :src="elmentList[1].phoneImg" v-else />
      </div>
      <div class="dec">
        <span v-animate="'queue-bottom'">{{
          elmentList[1].descList[0].descName
        }}</span>
      </div>
    </div>

    <!-- 左右排列参数 -->
    <div class="employmentPlan-content">
      <div class="content-tree" v-if="$store.state.pageset.pcshow">
        <div
          v-for="index in 4"
          :key="index"
          :id="'elm' + elmentList[index + 1].id"
        >
          <div class="p-title" v-if="index % 2 === 1">
            <p>
              {{ elmentList[index + 1].descList[0].descName }}
            </p>
            <p>{{ elmentList[index + 1].descList[1].descName }}</p>
          </div>

          <div class="fun-item" v-if="index % 2 === 0">
            <div class="fun-left">
              <img :src="elmentList[index + 1].pcImg" />
            </div>
            <div class="fun-right">
              <div class="fun-right-dec" v-animate="'queue-bottom'">
                <p class="p1">
                  {{ elmentList[index + 1].descList[0].descName }}
                </p>
                <p class="p2">
                  {{ elmentList[index + 1].descList[1].descName }}
                </p>
              </div>
            </div>
          </div>
          <div class="fun-item" v-else>
            <div class="fun-left">
              <div class="fun-right-dec" v-animate="'queue-bottom'">
                <p class="p1">
                  {{ elmentList[index + 1].descList[2].descName }}
                </p>
                <p class="p2">
                  {{ elmentList[index + 1].descList[1].descName }}
                </p>
              </div>
            </div>
            <div class="fun-right">
              <img :src="elmentList[index + 1].pcImg" />
            </div>
          </div>
        </div>
      </div>
      <div class="content-tree tree-black" v-if="!$store.state.pageset.pcshow">
        <div v-for="index in 2" :key="index">
          <div class="p-title" v-if="index % 2 === 1">
            <p>
              {{ elmentList[index + 1].descList[0].descName }}
            </p>
            <p>{{ elmentList[index + 1].descList[1].descName }}</p>
          </div>
          <div>
            <img
              :src="elmentList[index + 1].phoneImg"
              width="100%"
              height="100%"
            />
          </div>
          <div class="fun-dec" v-if="index % 2 === 1">
            <div class="fun-right-dec" v-animate="'queue-bottom'">
              <p class="p1">{{ elmentList[index + 1].descList[2].descName }}</p>
              <p class="p2">{{ elmentList[index + 1].descList[1].descName }}</p>
            </div>
          </div>
          <div class="fun-dec" v-else>
            <div class="fun-right-dec" v-animate="'queue-bottom'">
              <p class="p1">{{ elmentList[index + 1].descList[0].descName }}</p>
              <p class="p2">{{ elmentList[index + 1].descList[1].descName }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="content-tree tree-black" v-if="!$store.state.pageset.pcshow">
        <div v-for="index in 2" :key="index">
          <div class="p-title" v-if="index % 2 === 1">
            <p>
              {{ elmentList[index + 3].descList[0].descName }}
            </p>
            <p>{{ elmentList[index + 3].descList[1].descName }}</p>
          </div>
          <div>
            <img
              :src="elmentList[index + 3].phoneImg"
              width="100%"
              height="100%"
            />
          </div>
          <div class="fun-dec" v-if="index % 2 === 1">
            <div class="fun-right-dec" v-animate="'queue-bottom'">
              <p class="p1">{{ elmentList[index + 3].descList[2].descName }}</p>
              <p class="p2">{{ elmentList[index + 3].descList[1].descName }}</p>
            </div>
          </div>
          <div class="fun-dec" v-else>
            <div class="fun-right-dec" v-animate="'queue-bottom'">
              <p class="p1">{{ elmentList[index + 3].descList[0].descName }}</p>
              <p class="p2">{{ elmentList[index + 3].descList[1].descName }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 轮播图 -->
    <div class="content-fwo">
      <div class="mySwiper img-swiper">
        <div class="swiper-wrapper screen-swiper">
          <div
            class="swiper-slide"
            v-for="index in 3"
            :key="index"
            :id="'elm' + elmentList[index + 6].id"
          >
            <p class="p2" v-animate="'queue-bottom'">
              {{ elmentList[6].descList[0].descName }}
            </p>
            <!-- 滑动切换内容 -->
            <img
              :src="elmentList[index + 6].pcImg"
              v-if="$store.state.pageset.pcshow"
            />
            <img :src="elmentList[index + 6].phoneImg" v-else />
            <p v-if="!$store.state.pageset.pcshow" class="p4">
              {{ elmentList[index + 6].descList[0].descName }}
            </p>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-five" :id="'elm' + elmentList[10].id">
      <img
        v-if="this.$store.state.pageset.pcshow"
        class="video"
        :src="elmentList[11].pcImg"
        :ref="'video' + elmentList[11].pcElementId"
      />
      <img
        v-else
        class="video"
        :src="elmentList[11].phoneImg"
        :ref="'video' + elmentList[11].phoneElementId"
        :id="'videoOne'"
      />
      <div class="img-con">
        <div class="title">
          {{ elmentList[10].descList[0].descName }}
        </div>
      </div>
      <div class="dec" v-animate="'queue-bottom'">
        <div class="dec-par">
          <div class="dec-par-item" v-for="index in 4" :key="index">
            <p class="dec-par-item-title">
              {{ elmentList[11].descList[index - 1].descName }}
            </p>
            <p class="dec-par-item-dec">
              {{ elmentList[11].descList[index + 3].descName }}
            </p>
          </div>
        </div>
      </div>
      <div class="scroll-wrap">
        <div class="remark">
          {{ elmentList[11].descList[8].descName }}
        </div>
      </div>
    </div>

    <div class="content-six" :id="'elm' + elmentList[12].id">
      <div class="img-con">
        <img :src="elmentList[12].pcImg" v-if="$store.state.pageset.pcshow" />
        <img :src="elmentList[12].phoneImg" v-else />
      </div>
      <div class="dec">
        <span v-animate="'queue-bottom'">{{
          elmentList[12].descList[0].descName
        }}</span>
        <el-button
          size="small"
          class="btn-div-experience"
          plain
          @click="retention"
          >立即订购</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import employmentPlan_en from "./employmentPlan_en.js";

export default employmentPlan_en;
</script>
<style scoped rel="stylesheet/stylus" lang="scss">
@import "~@/assets/style/common.scss";
@import "../employmentPlan.scss";
</style>
